const lightTheme = {};

lightTheme.palette = {
  primary: [
    "#5850ec", // 0: primary color
  ],
  bgColor: ["#f3f6f8"],
  surfaceColor: ["#ffffff"],
  border: [
    "#d9d9d9", // 0: Border
  ],
  iconBg: [
    "#D7DADF", //0: icons background
  ],
  textColor: [
    "rgba(0, 0, 0, 0.85)", //0: text color
  ],
  focusColor: [
    "rgb(81, 174, 251)", //0: focus color
  ],
};

lightTheme.fonts = {
  primary: "Open Sans, sans-serif, Roboto",
  pre: "Consolas, Liberation Mono, Menlo, Courier, monospace",
};
lightTheme.name = "lightTheme";

export default lightTheme;
